import { render, staticRenderFns } from "./roleOperation.vue?vue&type=template&id=7578ba42&scoped=true"
import script from "./roleOperation.vue?vue&type=script&lang=js"
export * from "./roleOperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7578ba42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7578ba42')) {
      api.createRecord('7578ba42', component.options)
    } else {
      api.reload('7578ba42', component.options)
    }
    module.hot.accept("./roleOperation.vue?vue&type=template&id=7578ba42&scoped=true", function () {
      api.rerender('7578ba42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/roleManage/components/roleOperation.vue"
export default component.exports